import { Input, Select } from "antd"
import React, { useRef } from "react"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import SelectTypeSim from "src/components/Dropdown/SelectTypeSim"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "src/pages/ADMIN/HumanResource/styled"
import PublicSelectCountry from "../../PublicDropdown/PublicSelectCountry"
import PublicSelectNetWork from "../../PublicDropdown/PublicSelectNetwork"

const FilterPhoneNumber = ({ filter, setFilter }) => {
  const inputSearchRef = useRef()

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        <PublicSelectCountry style={{ width: 150, maxWidth: "100%" }} />
        <PublicSelectNetWork
          // onChange={val => setFilter(prev => ({ ...prev, carrier_id: val }))}
          style={{ width: 150, maxWidth: "100%" }}
        />
        <SelectTypeSim />
        <SelectSimType />
      </div>
      <div>
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm số điện thoại"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            // onPressEnter={onSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterPhoneNumber
